import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Calendar } from '@vendasta/meetings';

@Injectable({
  providedIn: 'root',
})
export class MeetingListSharedDataService {
  personalCalendar: Calendar;
  groupGeneralCalendar: Calendar[];

  setPersonalDefaultCalendar(personalCalendar$: Observable<Calendar>) {
    personalCalendar$.subscribe((value) => (this.personalCalendar = value));
  }

  getPersonalDefaultCalendar() {
    return this.personalCalendar;
  }
  setGroupCalendar(groupCalendarLink$: Observable<Calendar[]>) {
    groupCalendarLink$.subscribe((value) => {
      this.groupGeneralCalendar = value;
    });
  }

  getGroupCalendar() {
    return this.groupGeneralCalendar;
  }
}
